import { PopoverPage } from './about-popover';
import { PopoverController } from '@ionic/angular';
import { Component } from '@angular/core';

@Component({
  selector: 'page-about',
  styleUrls: ['about.scss'],
  templateUrl: 'about.html'
})
export class AboutPage {

  constructor(public popoverCtrl: PopoverController) { }

  async presentPopover(event: Event) {
    await (await this.popoverCtrl.create({
      component: PopoverPage,
      event: event
    })).present();
  }
  
}
